<script setup>
import { ref, onMounted } from 'vue';
import { useScrollAnimations } from '@/composables/useScrollAnimations';
import LandingCtaButton from './LandingCtaButton.vue';
import nis2Img from '@/assets/nis2.png';

const { animateInView, slideRight, slideLeft } = useScrollAnimations();
const sectionRef = ref(null);
const leftColRef = ref(null);
const rightColRef = ref(null);

onMounted(() => {
    if (sectionRef.value) {
        // animateInView(sectionRef.value, () => {});
    }
    if (leftColRef.value && rightColRef.value) {
        animateInView(leftColRef.value, () => {
            slideRight(leftColRef.value);
            slideLeft(rightColRef.value);
        });
    }
});
</script>

<template>
    <div class="py-24 relative" ref="sectionRef">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">

                <!-- Text Content (Left) -->
                <div ref="leftColRef" class="opacity-0">
                    <h2 class="text-3xl font-bold tracking-tight text-white sm:text-4xl mb-6"
                        v-html="$t('landingPage.v2.nis2.title')">
                    </h2>

                    <p class="text-lg text-gray-300 mb-6 leading-relaxed">
                        {{ $t('landingPage.v2.nis2.text1') }}
                    </p>

                    <p class="text-lg text-gray-300 mb-10 leading-relaxed">
                        {{ $t('landingPage.v2.nis2.text2') }}
                    </p>

                    <div>
                        <LandingCtaButton sectionName="NIS2" :text="$t('landingPage.v2.cta.nis2')" />
                    </div>
                </div>

                <!-- Image (Right) -->
                <div ref="rightColRef" class="opacity-0">
                    <a href="https://www.enisa.europa.eu/topics/awareness-and-cyber-hygiene/raising-awareness-campaigns/network-and-information-systems-directive-2-nis2"
                        target="_blank" rel="noopener noreferrer" class="block">
                        <div
                            class="relative w-full rounded-xl overflow-hidden border border-white/10 shadow-2xl flex items-center justify-center hover:border-white/20 transition-colors">
                            <img :src="nis2Img" alt="NIS-2 Network & Information Systems Directive"
                                class="w-full h-auto object-contain">
                        </div>
                    </a>
                    <a href="https://www.enisa.europa.eu/topics/awareness-and-cyber-hygiene/raising-awareness-campaigns/network-and-information-systems-directive-2-nis2"
                        target="_blank" rel="noopener noreferrer"
                        class="text-xs text-gray-400 mt-2 block text-center hover:text-white transition-colors">
                        {{ $t('landingPage.v2.nis2.euAgency') }}
                    </a>
                </div>

            </div>
        </div>
    </div>
</template>

<style scoped></style>
